import React from 'react';
import { useForm } from 'react-hook-form';
import Button from '../UI/Button';

const DepartmentForm = ({ department, onSubmit, onCancel }) => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: department || {
      name: '',
    }
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Department Name *
        </label>
        <input
          type="text"
          {...register('name', { required: 'Department name is required' })}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-primary-500 focus:border-primary-500"
          placeholder="e.g., Human Resources, Information Technology, Quality Assurance"
        />
        {errors.name && (
          <p className="mt-1 text-sm text-red-600">{errors.name.message}</p>
        )}
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <Button variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">
          {department ? 'Update Department' : 'Add Department'}
        </Button>
      </div>
    </form>
  );
};

export default DepartmentForm;